module.exports = __webpack_public_path__ + "img/money_back.f9674095.png";